import React from 'react';

/**
 * Compact vertically-stacked numbered hotspots for dashboard appreciation cards.
 * Matches the columnLeft style from ArtAnalysisHotspots during live appreciation.
 */
export default function AppreciationHotspotPreview({ count = 4, className = '' }) {
  const total = Math.min(Math.max(Number(count) || 4, 1), 4);

  return (
    <div
      className={`absolute left-1.5 top-1/2 -translate-y-1/2 flex flex-col items-center gap-1 z-30 pointer-events-none ${className}`}
      aria-hidden="true"
    >
      {Array.from({ length: total }, (_, idx) => (
        <div
          key={idx}
          className="w-5 h-5 flex items-center justify-center rounded-full font-bold text-white text-[9px] bg-gradient-to-br from-amber-500 to-amber-400 shadow-md ring-1 ring-white"
        >
          {idx + 1}
        </div>
      ))}
    </div>
  );
}
